module.exports = __webpack_public_path__ + "static/media/not-available.be940c4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/not-available.jpg
// module id = 881
// module chunks = 0